import { render, staticRenderFns } from "./TankProducts.vue?vue&type=template&id=5f0d2d5d"
import script from "./TankProducts.vue?vue&type=script&lang=js"
export * from "./TankProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports